/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  isDemo,
  nickname,
  objectId,
  objectIds,
  password,
  reason,
  systemGameId,
  uplineId,
  username,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createCustomerDownlines: {
    properties: {
      body: {
        properties: {
          isDemo,
          nickname,
          password,
          username,
        },
        required: [
          'isDemo',
          'nickname',
          'password',
          'username',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
        },
        required: ['customerId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerDownlinesBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  recoverCustomerDownlinesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  removeCustomerDownlinesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  updateCustomerDownlineById: {
    properties: {
      body: {
        properties: {
          uplineId,
        },
        required: ['uplineId'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
